import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SchemaOrg from "@/components/feature/SchemaOrg";

const formSubmitUrl = "http://yuanyunge.cn/";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SchemaOrg
        type="WebPage"
        data={{
          name: "404 - 页面未找到",
          url: "http://yuanyunge.cn/404",
          description: "您访问的页面不存在，请返回樱花动漫网首页浏览精彩内容。",
          inLanguage: "zh-CN",
        }}
      />
      <Navbar />

      <main className="flex-1 flex items-center justify-center px-4 md:px-8 py-24">
        <div className="text-center max-w-md">
          <div className="relative mb-8">
            <span className="text-9xl md:text-[12rem] font-black text-background-200 select-none">
              404
            </span>
            <div className="absolute inset-0 flex items-center justify-center">
              <i className="ri-error-warning-line text-6xl text-foreground-300"></i>
            </div>
          </div>

          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            页面未找到
          </h1>
          <p className="text-foreground-500 text-sm mb-8">
            抱歉，您访问的页面不存在或已被移除。
            <br />
            请返回首页继续浏览精彩内容。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/category/japanese-anime"
              className="inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-movie-2-line"></i>
              浏览动漫
            </Link>
          </div>
        </div>
      </main>

      <Footer formUrl={formSubmitUrl} />
    </div>
  );
}